import { Table } from '@mantine/core';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { SearchField } from '../../components/SearchField';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilterPageAndSearch } from '../../util/api/queryWithFilterPageAndSearch';
import { formatToCurrency, formatToDateString } from '../../util/formatting';
import { undefinedCheck } from '../../util/undefinedCheck';
import type { PaidInOutDto } from './types/PaidInOutDto';
import { KeyedRow } from '../../components/KeyedRow';

export function PaidInOut() {
	const { organisation } = useParams();
	const pagination = usePagination();
	const filter = useFilter();
	const [searchQuery, setSearchQuery] = useState('');

	const missedItemsCountQuery = queryWithFilterPageAndSearch<number>(
		`${organisation}/paid-in-out/count`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	const missedItemsQuery = queryWithFilterPageAndSearch<PaidInOutDto[]>(
		`${organisation}/paid-in-out/all`,
		filter.value,
		pagination.value,
		searchQuery,
	);

	return (
		<>
			<PageHeader title={'Paid In/Out'} filter={filter}>
				<SearchField
					placeholder={'Search reasons...'}
					onDelayComplete={(value) => setSearchQuery(value)}
					width={'20vw'}
				/>
			</PageHeader>
			<DataTable
				pagination={pagination}
				totalItems={missedItemsCountQuery.data?.value}
				isRowsLoading={missedItemsQuery.isLoading}
				isPaginationLoading={missedItemsCountQuery.isLoading}
				rows={pagination.value.pageSize}
				minHeight={'67vh'}
				maxHeight={'76vh'}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Till'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Amount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Reason'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Tender'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Description'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{missedItemsQuery.data?.value.map(
						(missedItem: PaidInOutDto, index: number) => (
							<KeyedRow>
								<Table.Td>{formatToDateString(missedItem.dateTime)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.till)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.branch)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.operator)}</Table.Td>
								<Table.Td>{formatToCurrency(missedItem.amount)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.reason)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.tender)}</Table.Td>
								<Table.Td>{undefinedCheck(missedItem.description)}</Table.Td>
							</KeyedRow>
						),
					)}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
